/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Unranked_BadgeInputs */



/**
* | output |
* | --- |
* | "Unranked" |
*
* @param {Tournament_Unranked_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_unranked_badge = /** @type {((inputs?: Tournament_Unranked_BadgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Unranked_BadgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non classé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No clasificado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não classificado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non classificato")
	return /** @type {LocalizedString} */ ("Unranked")
});